















import { Component, Vue } from 'vue-property-decorator';
import global from '../utils/global';
@Component({})
export default class Carousel extends Vue {
  private imgUrl: string = `${global.BACKGROUND_URL}home/`;
}
